import React from "react";
import {Box, IconButton, Snackbar} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {useRecoilState, useRecoilValue} from "recoil";
// import {snackBarMessageState} from "../Recoil/Atom/SnackBarAtom";
import {
  snackBarMessageState,
  snackBarState,
  snackBarToggleState,
} from "../Recoil/Atom/snackBarState";

const MWSnackbar = () => {
  const [snackBarToggle, setSnackBarToggle] = useRecoilState(snackBarToggleState);
  const snackBarMessage = useRecoilValue(snackBarMessageState);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarToggle(false);
  };

  const action = (
    <Box>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );

  return (
    <div>
      <Snackbar
        open={snackBarToggle}
        autoHideDuration={2000}
        onClose={handleClose}
        message={snackBarMessage}
        action={action}
      />
    </div>
  );
};

export default MWSnackbar;
